import React from "react";
import { Box } from "@mui/material";
import PracticeArea from "./PracticeArea";
import { ScheduleFilterArea } from "./ScheduleFiltering";
import { useSelector } from "react-redux";
import { getUserPermissionsList } from "selectors";

const ScheduleUtilityDrawer = (props) => {
  const {
    filteredList,
    getClientSessions,
    showWeekCanceledCalls,
    handleSwitchChange,
    toggleScheduleUtilityDrawer,
    getUserSchedule,
    userId,
    peopleFilters,
    setPeopleFilters,
    selectedServices,
    setSelectedServices,
    showScheduleUtilityDrawer,
    isClinician,
    showSupervisoryEvents,
    handleToggleShowSupervisoryEvents,
    showTentativeEvents,
    handleToggleTentativeEvents,
    colorIndexManager,
    filterByURL,
  } = props;

  const userPermissions = useSelector(getUserPermissionsList);

  return (
    showScheduleUtilityDrawer && (
      <Box width={"300px"} sx={{ overflowY: "auto", borderRight: "1px solid #CDD3DA" }}>
        <ScheduleFilterArea
          toggleScheduleUtilityDrawer={toggleScheduleUtilityDrawer}
          userPermissions={userPermissions}
          showNoShows={showWeekCanceledCalls}
          setShowNoShows={handleSwitchChange}
          getUserSchedule={getUserSchedule}
          searchResults={filteredList}
          getClientSessions={getClientSessions}
          colorIndexManager={colorIndexManager}
          userId={userId}
          peopleFilters={peopleFilters}
          setPeopleFilters={setPeopleFilters}
          selectedServices={selectedServices}
          setSelectedServices={setSelectedServices}
          showSupervisoryEvents={showSupervisoryEvents}
          handleToggleShowSupervisoryEvents={handleToggleShowSupervisoryEvents}
          showTentativeEvents={showTentativeEvents}
          handleToggleTentativeEvents={handleToggleTentativeEvents}
          filterByURL={filterByURL}
        />
        {isClinician && <PracticeArea {...props} />}
      </Box>
    )
  );
};

export default ScheduleUtilityDrawer;
